import { LoadableAfterPaint } from '@confluence/loadable';

export const SuperAdminBanner = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SuperAdminBanner" */ '../src/SuperAdminBanner.tsx'))
			.SuperAdminBanner,
});
